import { UserEntity } from '@data';
import React, { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import { OrganizationsInit } from './init';
import Organization from './organization';

export interface OrganizationsProps {
  user: UserEntity;
}

/** Paths are relative to parent `${organizationsPath}/*` (React Router v6 descendant routes). */
const Organizations = ({ user }: OrganizationsProps): ReactElement => (
  <Routes>
    <Route index element={<OrganizationsInit user={user} />} />
    <Route path=":organizationId/*" element={<Organization user={user} />} />
  </Routes>
);

export default Organizations;
